import React, { useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import {
  deleteEmployeeExperience,
  getEmployeeExpriences,
} from "../Service/profileService";
import { TostMsg } from "../../../../App";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";

function UserExperience({ employeeId }) {
  const [Isloading, setIsloading] = useState(false);
  const [showContent, setSeleteContent] = useState([]);
  const toster = useContext(TostMsg);
  const [DeleteacademicId, setDeleteacademicId] = useState(0);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [expriencesData, setExpriencesList] = useState();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let history = useHistory();
  useEffect(() => {
    if (employeeId) {
      getEmployeeExpriencesList();
    }
  }, [employeeId]);

  async function getEmployeeExpriencesList() {
    const params = {
      OrgId: userDetails.OrgId,
      ExperienceId: 0,
      EmpId: employeeId,
    };
    try {
      const response = await getEmployeeExpriences(params);
      let ExpriencesDatalist = response?.Data;

      const sortedData = [...ExpriencesDatalist].sort(
        (a, b) => new Date(b.EndDate) - new Date(a.EndDate)
      );
      setExpriencesList(sortedData);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function deleteAcademicDetails() {
    if (DeleteacademicId) {
      let body = {
        Id: DeleteacademicId,
        ModifiedBy: userDetails?.EmpId,
      };
      setIsloading(true);
      try {
        let experiencesList = await deleteEmployeeExperience(body);
        if (experiencesList) {
          GetMasterSystemAlertList("Experience_Deleted", 0);
          getEmployeeExpriencesList();
          setIsloading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    }
  }

  async function editExperience(editExperienceDetails) {
    history.push(`/Experience/${editExperienceDetails?.id}`);
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const addExprience = () => {
    history.push(`/AddExperience`);
  };

  return (
    <div>
      <div className="profile-about-me  position-relation">
        <div className="pt-3 border-bottom-1">
          <div className="mb-0">
            <h4 className="text-primary mb-3 sumh4 addprofile-action">
              Experience
              {userDetails?.EmpId == employeeId && (
                <span>
                  <a
                    className="edit-btncss mb-2 love-icon"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Add Experience"
                    data-bs-toggle="modal"
                    data-bs-target="#add-eexp"
                    onClick={() => {
                      addExprience();
                    }}
                  >
                    <img
                      src="/images/org-img/profile/add.png"
                      className="w-100"
                    />{" "}
                  </a>
                </span>
              )}
            </h4>
            <div className="row">
              <div className="col-12">
                <div className="icon-timeline">
                  {expriencesData?.map((experiences, index) => {
                    return (
                      <div className="timeline-item" key={index}>
                        {userDetails?.EmpId == employeeId && (
                          <img
                            onClick={() => {
                              setDeleteacademicId(experiences?.id);
                              GetMasterSystemAlertList("Delete_Experience", 1);
                            }}
                            style={{ marginTop: "10px" }}
                            src="/images/org-img/delete.png"
                            className="side-pen-icon"
                            title="Delete"
                            data-bs-toggle="modal"
                            data-bs-target="#delete-ede"
                          />
                        )}
                        {userDetails?.EmpId == employeeId && (
                          <img
                            onClick={() => {
                              editExperience(experiences);
                              GetMasterSystemAlertList("edit_experience", 1);
                            }}
                            style={{
                              marginRight: "24px",
                              marginTop: "10px",
                            }}
                            src="/images/org-img/edit.png"
                            title="Edit"
                            className="side-pen-icon"
                            data-bs-toggle="modal"
                            data-bs-target="#add-eexp"
                          />
                        )}
                        <div className="timeline-icon is-squared">
                          <img
                            className="avatar"
                            src="/images/profile/Experience.svg"
                          />
                        </div>
                        <div className="timeline-content">
                          <h5 className="exp-des">
                            {experiences?.Designation}
                          </h5>
                          <p className="mb-1 exp-format mt-2">
                            <b>{experiences?.Company}</b>
                            {experiences?.Technology && (
                              <b>&nbsp;- {experiences?.Technology}</b>
                            )}
                          </p>
                          {experiences?.ProjectDetails && (
                            <p className="mb-1 exp-format">
                              <b>Project Detail :</b>                              
                              <div dangerouslySetInnerHTML={{
                                  __html: experiences?.ProjectDetails }} />
                                   
                            </p>
                           
                          )}
                          {experiences?.Responsibilities && (
                            <p className="mb-1 exp-format">
                              <b>Responsibilities :</b> &nbsp;
                              {experiences?.Responsibilities},
                            </p>
                          )}
                          <p className="mb-1 ">
                            <span>
                              {moment(experiences?.StartDate).format(
                                "MMM DD YYYY"
                              )}&nbsp;-&nbsp;
                              {experiences?.CurrentlyWorkingHere === true ? (
                                <span>Present</span>
                              ) : (
                                <>
                                  {moment(experiences?.EndDate).format(
                                    "MMM DD YYYY"
                                  )}
                                </>
                              )}
                              {experiences?.Location && (
                                <>&nbsp;&nbsp;•&nbsp;{experiences?.Location}</>
                              )}
                            </span>
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-ede">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{showContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteAcademicDetails()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      {Isloading ? <ComponentLoader /> : ""}
    </div>
  );
}
export default UserExperience;
